export default {
  'pages.layouts.userLayout.title': 'AimerPay - Adyen 余额平台管理系统',

  // Login
  'pages.login.welcome': '欢迎回来',
  'pages.login.subtitle': '登录您的商户账户',
  'pages.login.brandDescription': '为澳大利亚和新西兰商户提供专业支付平台',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage': '用户名或密码错误',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.userName.placeholder': '用户名或邮箱',
  'pages.login.userName.required': '请输入用户名或邮箱',
  'pages.login.email.placeholder': '邮箱地址',
  'pages.login.email.required': '请输入您的邮箱地址',
  'pages.login.email.invalid': '请输入有效的邮箱地址',
  'pages.login.password.placeholder': '密码',
  'pages.login.password.required': '请输入您的密码',
  'pages.login.forgotPassword': '忘记密码？',
  'pages.login.forgotPassword.title': '重置密码',
  'pages.login.forgotPassword.description':
    '请输入您的邮箱地址，我们将向您发送密码重置链接。',
  'pages.login.forgotPassword.emailPlaceholder': '请输入邮箱地址',
  'pages.login.forgotPassword.emailRequired': '请输入邮箱',
  'pages.login.forgotPassword.emailInvalid': '请输入有效的邮箱地址',
  'pages.login.forgotPassword.submit': '发送重置链接',
  'pages.login.forgotPassword.success':
    '如果该邮箱已注册，密码重置链接将会发送到您的邮箱。',
  'pages.login.forgotPassword.error': '发送重置邮件失败，请重试。',
  'pages.login.submit': '登录',
  'pages.login.noAccount': '还没有账户？',
  'pages.login.contactAdmin': '请联系管理员',
  'pages.login.sessionExpired': '登录已过期，请重新登录。',

  // 403
  'pages.403.subTitle': '抱歉，您无权访问该页面。',
  'pages.403.buttonText': '返回首页',

  // 404
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',

  // Dashboard
  'pages.dashboard.title': '仪表盘',
  'pages.dashboard.totalBalance': '总余额',
  'pages.dashboard.accountHolders': '账户持有人',
  'pages.dashboard.currentMerchant': '当前商家',
  'pages.dashboard.pendingTransfers': '待处理转账',
  'pages.dashboard.todayTransactions': '今日交易',
  'pages.dashboard.recentTransactions': '最近交易',
  'pages.dashboard.recentTransactionsCount': '交易数量',
  'pages.dashboard.inLast7Days': '条近期',
  'pages.dashboard.balanceOverview': '余额概览',
  'pages.dashboard.quickActions': '快捷操作',
  'pages.dashboard.viewAll': '查看全部',
  'pages.dashboard.noBalanceAccounts': '暂无余额账户',
  'pages.dashboard.noTransactions': '暂无近期交易',
  'pages.dashboard.moreAccounts': '个更多账户',
  'pages.dashboard.column.type': '类型',

  // Partners (Business API)
  'pages.partners.title': '客户',
  'pages.partners.emptySubtitle': '管理您的商户账户',
  'pages.partners.id': '客户ID',
  'pages.partners.name': '名称',
  'pages.partners.legalEntity': '法律实体',
  'pages.partners.status': '状态',
  'pages.partners.capabilities': '功能权限',
  'pages.partners.createdAt': '创建时间',
  'pages.partners.actions': '操作',
  'pages.partners.enterWorkspace': '进入',
  'pages.partners.edit': '编辑',
  'pages.partners.onboard': '入驻',
  'pages.partners.create': '创建客户',
  'pages.partners.create.success': '客户创建成功',
  'pages.partners.create.error': '创建客户失败',
  'pages.partners.create.button.withProfile': '创建客户 · {profile}',
  'pages.partners.create.confirm.title': '确认创建 {profile} 客户？',
  'pages.partners.create.confirm.title.default': '确认创建客户？',
  'pages.partners.create.confirm.content':
    '创建后账户类型无法更改，请确认后再继续。',
  'pages.partners.create.confirm.ok': '确认创建',
  'pages.partners.create.cancel': '取消',
  'pages.partners.create.profileLocked':
    '正在创建 {profile}（{merchantAccount}）客户。此账户类型已锁定，创建后不可更改。',
  'pages.partners.editTitle': '编辑客户信息',
  'pages.partners.editSuccess': '客户信息更新成功',
  'pages.partners.editError': '更新客户信息失败',
  'pages.partners.edit.addressLocked':
    'Adyen 法人实体已创建，法定名称和地址不能在此修改，请通过 Adyen 入驻流程更新。',
  'pages.partners.column.type': '类型',
  'pages.partners.column.email': '邮箱',
  'pages.partners.column.adyenStatus': 'Adyen 状态',
  'pages.partners.column.balanceAccounts': '余额账户',
  'pages.partners.column.adyenProfile': 'Adyen 方案',
  'pages.partners.status.Draft': '草稿',
  'pages.partners.status.Pending': '待审核',
  'pages.partners.status.Active': '已激活',
  'pages.partners.status.Suspended': '已暂停',
  'pages.partners.status.Rejected': '已拒绝',
  // Admin partner access request workflow
  'pages.partners.access.column': '访问权限',
  'pages.partners.access.expiresAt': '到期时间',
  'pages.partners.access.none': '未申请',
  'pages.partners.access.pending': '审批中',
  'pages.partners.access.active': '已授权',
  'pages.partners.access.expired': '已过期',
  'pages.partners.access.rejected': '已拒绝',
  'pages.partners.access.enter': '进入',
  'pages.partners.access.request': '申请访问',
  'pages.partners.access.cancel': '取消申请',
  'pages.partners.access.cancelConfirm': '确定取消这个访问申请吗？',
  'pages.partners.access.requestSuccess': '访问申请已提交',
  'pages.partners.access.cancelSuccess': '申请已取消',
  // Partner Form
  'pages.partners.form.type': '类型',
  'pages.partners.form.type.placeholder': '请选择客户类型',
  'pages.partners.form.type.required': '请选择类型',
  'pages.partners.form.type.organization': '企业',
  'pages.partners.form.type.individual': '个人',
  'pages.partners.type.org.short': '企业',
  'pages.partners.type.ind.short': '个人',
  'pages.partners.form.firstName': '名',
  'pages.partners.form.firstName.placeholder': '请输入名',
  'pages.partners.form.firstName.required': '个人必须填写名',
  'pages.partners.form.lastName': '姓',
  'pages.partners.form.lastName.placeholder': '请输入姓',
  'pages.partners.form.lastName.required': '个人必须填写姓',
  'pages.partners.form.street': '街道地址',
  'pages.partners.form.street.placeholder': '请输入街道地址',
  'pages.partners.form.street.required': '街道地址为必填项',
  'pages.partners.form.street.invalidChars':
    '地址不能包含中文或全角字符（如 ，。），请使用英文半角字符',
  'pages.partners.form.city': '城市',
  'pages.partners.form.city.placeholder': '请输入城市',
  'pages.partners.form.city.select.placeholder': '选择城市',
  'pages.partners.form.city.required': '城市为必填项',
  'pages.partners.form.postalCode': '邮政编码',
  'pages.partners.form.postalCode.placeholder': '请输入邮政编码',
  'pages.partners.form.postalCode.required': '邮政编码为必填项',
  'pages.partners.form.postalCode.formatInvalid': '邮政编码必须为 4 位数字',
  'pages.partners.form.stateOrProvince': '省/州',
  'pages.partners.form.stateOrProvince.placeholder': '请输入省或州（可选）',
  'pages.partners.form.stateOrProvince.autoFilled': '自动填充',
  'pages.partners.form.partnerName': '客户名称',
  'pages.partners.form.partnerName.placeholder': '请输入客户名称',
  'pages.partners.form.partnerName.required': '请输入客户名称',
  'pages.partners.form.legalName': '法定企业名称',
  'pages.partners.form.legalName.placeholder': '请输入法定企业名称',
  'pages.partners.form.legalName.required': '请输入法定名称',
  'pages.partners.form.reference': '参考编号',
  'pages.partners.form.reference.tooltip':
    '该商户的唯一标识符（例如：merchant-123）',
  'pages.partners.form.reference.placeholder': '请输入唯一参考编号（可选）',
  'pages.partners.form.reference.pattern': '只允许字母、数字、连字符和下划线',
  'pages.partners.form.country': '国家',
  'pages.partners.form.country.placeholder': '请选择国家',
  'pages.partners.form.country.required': '请选择国家',
  'pages.partners.form.country.AU': '澳大利亚',
  'pages.partners.form.country.NZ': '新西兰',
  'pages.partners.form.adyenProfile': 'Adyen 账号方案',
  'pages.partners.form.adyenProfile.tooltip':
    '决定该商户开在哪个 Adyen merchant account 下，以及默认的抽佣方案。该商户创建门店后不可再更改。',
  'pages.partners.form.adyenProfile.placeholder': '使用默认方案',
  'pages.partners.form.adyenProfile.editHint':
    '仅在该商户尚未创建任何门店时可更改。',
  'pages.partners.form.adyenProfile.hasStores':
    '该商户已有门店，Adyen 账号方案不可再修改。',
  'pages.partners.form.businessType': '业务类型',
  'pages.partners.form.businessType.placeholder': '请选择您的业务类型',
  'pages.partners.form.businessType.required': '请选择业务类型',
  'pages.partners.form.businessType.restaurant': '餐厅 (堂食)',
  'pages.partners.form.businessType.fastFood': '快餐 / 外卖',
  'pages.partners.form.businessType.cafe': '咖啡店 / 奶茶店',
  'pages.partners.form.businessType.bar': '酒吧',
  'pages.partners.form.businessType.supermarket': '超市 / 杂货店',
  'pages.partners.form.businessType.specialtyFood': '专门食品店',
  'pages.partners.form.businessType.laundry': '洗衣及干洗服务(通用)',
  'pages.partners.form.businessType.laundromat': '自助洗衣店',
  'pages.partners.form.businessType.dryCleaner': '干洗店',
  'pages.partners.form.salesChannels': '销售渠道',
  'pages.partners.form.salesChannels.required': '请选择一个销售渠道',
  'pages.partners.form.salesChannels.pos': 'POS',
  'pages.partners.form.salesChannels.pos.desc': '适用于店内 POS 终端销售和支付',
  'pages.partners.form.salesChannels.ecommerce': 'eCommerce',
  'pages.partners.form.salesChannels.ecommerce.desc':
    '适用于通过网站或应用进行的在线销售',
  'pages.partners.form.websiteUrl': '网站地址',
  'pages.partners.form.websiteUrl.placeholder': 'https://your-website.com',
  'pages.partners.form.websiteUrl.hint':
    '选择电子商务时必填，多个地址用逗号分隔',
  'pages.partners.form.websiteUrl.required':
    '选择电子商务渠道时必须填写网站地址',
  'pages.partners.form.websiteUrl.invalid':
    '请输入有效的 URL 地址（以 http:// 或 https:// 开头）',
  'pages.partners.form.email': '电子邮箱',
  'pages.partners.form.email.placeholder': '请输入联系邮箱',
  'pages.partners.form.email.required': '请输入邮箱',
  'pages.partners.form.email.invalid': '请输入有效的邮箱地址',
  'pages.partners.form.paymentMethods': '支付方式',
  'pages.partners.form.paymentMethods.required': '请至少选择一种支付方式',
  'pages.partners.form.paymentMethods.visa': 'Visa',
  'pages.partners.form.paymentMethods.mc': '万事达卡',
  'pages.partners.form.paymentMethods.amex': '美国运通',
  'pages.partners.form.description': '描述',
  'pages.partners.form.description.placeholder': '请输入描述（可选）',

  // Account Holders (Legacy - keep for backward compatibility)
  'pages.accountHolders.title': '客户',
  'pages.accountHolders.emptySubtitle': '管理您的商户账户',
  'pages.accountHolders.id': '客户ID',
  'pages.accountHolders.name': '名称',
  'pages.accountHolders.legalEntity': '法律实体',
  'pages.accountHolders.status': '状态',
  'pages.accountHolders.capabilities': '功能权限',
  'pages.accountHolders.createdAt': '创建时间',
  'pages.accountHolders.actions': '操作',
  'pages.accountHolders.view': '查看',
  'pages.accountHolders.edit': '编辑',
  'pages.accountHolders.onboard': '入驻',
  'pages.accountHolders.create': '创建客户',
  'pages.accountHolders.create.success': '客户创建成功',
  'pages.accountHolders.status.active': '活跃',
  'pages.accountHolders.status.inactive': '未激活',
  'pages.accountHolders.status.suspended': '已暂停',
  'pages.accountHolders.status.closed': '已关闭',
  // Create Account Holder Form (Legacy)
  'pages.accountHolders.form.partnerName': '客户名称',
  'pages.accountHolders.form.partnerName.placeholder': '请输入客户名称',
  'pages.accountHolders.form.partnerName.required': '请输入客户名称',
  'pages.accountHolders.form.legalName': '法定企业名称',
  'pages.accountHolders.form.legalName.placeholder': '请输入法定企业名称',
  'pages.accountHolders.form.legalName.required': '请输入法定名称',
  'pages.accountHolders.form.reference': '参考编号',
  'pages.accountHolders.form.reference.tooltip':
    '该商户的唯一标识符（例如：merchant-123）',
  'pages.accountHolders.form.reference.placeholder':
    '请输入唯一参考编号（可选）',
  'pages.accountHolders.form.reference.pattern':
    '只允许字母、数字、连字符和下划线',
  'pages.accountHolders.form.country': '国家',
  'pages.accountHolders.form.country.placeholder': '请选择国家',
  'pages.accountHolders.form.country.required': '请选择国家',
  'pages.accountHolders.form.country.AU': '澳大利亚',
  'pages.accountHolders.form.country.NZ': '新西兰',
  'pages.accountHolders.form.businessType': '业务类型',
  'pages.accountHolders.form.businessType.placeholder': '请选择业务类型',
  'pages.accountHolders.form.businessType.retail': '零售',
  'pages.accountHolders.form.businessType.food_beverage': '餐饮',
  'pages.accountHolders.form.businessType.professional_services': '专业服务',
  'pages.accountHolders.form.businessType.ecommerce': '电子商务',
  'pages.accountHolders.form.businessType.other': '其他',
  'pages.accountHolders.form.email': '电子邮箱',
  'pages.accountHolders.form.email.placeholder': '请输入联系邮箱',
  'pages.accountHolders.form.email.required': '请输入邮箱',
  'pages.accountHolders.form.email.invalid': '请输入有效的邮箱地址',
  'pages.accountHolders.form.description': '描述',
  'pages.accountHolders.form.description.placeholder': '请输入描述（可选）',

  // Balance Accounts
  'pages.balanceAccounts.title': '余额账户',
  'pages.balanceAccounts.id': '账户ID',
  'pages.balanceAccounts.accountHolder': '账户持有人',
  'pages.balanceAccounts.description': '描述',
  'pages.balanceAccounts.balance': '余额',
  'pages.balanceAccounts.balance.pending': '待处理',
  'pages.balanceAccounts.currency': '币种',
  'pages.balanceAccounts.currency.selectPlaceholder': '请选择币种',
  'pages.balanceAccounts.currency.selectRequired': '请选择币种',
  'pages.balanceAccounts.timeZone': '时区',
  'pages.balanceAccounts.timeZone.selectPlaceholder': '请选择时区',
  'pages.balanceAccounts.timeZone.required': '请选择时区',
  'pages.balanceAccounts.partner': '客户',
  'pages.balanceAccounts.balance.available': '可用',
  'pages.balanceAccounts.notFound': '余额账户未找到',
  'pages.balanceAccounts.notFoundDesc':
    'ID 为 {id} 的余额账户不存在或您没有访问权限。',
  'pages.balanceAccounts.status': '状态',
  'pages.balanceAccounts.status.active': '已激活',
  'pages.balanceAccounts.status.inactive': '未激活',
  'pages.balanceAccounts.createdAt': '创建时间',
  'pages.balanceAccounts.actions': '操作',
  'pages.balanceAccounts.view': '查看',
  'pages.balanceAccounts.manage': '管理',
  'pages.balanceAccounts.create': '创建余额账户',
  'pages.balanceAccounts.create.success': '余额账户创建成功',
  'pages.balanceAccounts.edit': '编辑余额账户',
  'pages.balanceAccounts.edit.success': '余额账户更新成功',
  'pages.balanceAccounts.status.suspended': '已暂停',
  'pages.balanceAccounts.status.selectPlaceholder': '请选择状态',
  'pages.balanceAccounts.empty': '暂无余额账户。完成入驻后可创建余额账户。',

  // Transactions
  'pages.transactions.title': '交易记录',
  'pages.transactions.selectAccount': '选择余额账户',
  'pages.transactions.noAccount': '请先选择一个余额账户',
  'pages.transactions.noBalanceAccounts': '暂无余额账户，请先创建余额账户。',
  'pages.transactions.amount': '金额',
  'pages.transactions.status': '状态',
  'pages.transactions.createdAt': '创建时间',

  // Payouts
  'pages.payouts.title': '支付管理',
  'pages.payouts.selectAccount': '选择余额账户',
  'pages.payouts.noAccount': '请先选择一个余额账户',
  'pages.payouts.noBalanceAccounts': '暂无余额账户，请先创建余额账户。',

  // Onboarding
  'pages.onboarding.title': '商户入驻',
  'pages.onboarding.description':
    '通过 Adyen Hosted Onboarding 完成商户入驻流程',
  'pages.onboarding.startOnboarding': '开始入驻',
  'pages.onboarding.continue': '继续入驻',
  'pages.onboarding.status': '入驻状态',
  'pages.onboarding.pending': '待处理',
  'pages.onboarding.inProgress': '进行中',
  'pages.onboarding.completed': '已完成',
  'pages.onboarding.rejected': '已拒绝',
  'pages.onboarding.createMerchant.title': '创建新商户',
  'pages.onboarding.createMerchant.description':
    '开始入驻流程以添加新商户到您的账户。您需要提供商业信息并通过 Adyen 完成 KYC 验证。',
  'pages.onboarding.createMerchant.button': '添加新商户',
  'pages.onboarding.merchantList.title': '您的商户',
  'pages.onboarding.noMerchants': '暂无商户。创建您的第一个商户以开始使用。',
  'pages.onboarding.createFirst': '创建第一个商户',
  'pages.onboarding.viewDetails': '查看详情',
  'pages.onboarding.linkOpened': '入驻页面已在新标签页打开',
  'pages.onboarding.linkError': '获取入驻链接失败',
  'pages.onboarding.createInfo': '创建新商户需要后端与 Adyen 集成',
  'pages.onboarding.refreshed': '商户列表已刷新',
  'pages.onboarding.status.pending': '待处理',
  'pages.onboarding.status.inProgress': '进行中',
  'pages.onboarding.status.completed': '已完成',
  'pages.onboarding.status.rejected': '已拒绝',
  // Onboarding Callback
  'pages.onboarding.callback.processing': '正在处理入驻结果...',
  'pages.onboarding.callback.processingDesc':
    '请稍候，我们正在更新您的账户信息。这可能需要一些时间。',
  'pages.onboarding.callback.success': '入驻成功完成！',
  'pages.onboarding.callback.successDesc':
    '您的KYC信息已提交。Adyen将审核您的信息，审核完成后会通知您。',
  'pages.onboarding.callback.successRedirect':
    '您将很快被重定向到账户持有人页面。',
  'pages.onboarding.callback.failed': '入驻失败',
  'pages.onboarding.callback.failedDesc':
    '处理入驻时发生错误。请重试或联系客服。',
  'pages.onboarding.callback.returnMerchants': '返回商户列表',

  // Setup Adyen
  'pages.partners.setupAdyen': '设置 Adyen',
  'pages.partners.setupAdyen.title': '配置 Adyen 集成',
  'pages.partners.setupAdyen.success': 'Adyen 设置成功',
  'pages.partners.setupAdyen.error': 'Adyen 设置失败',
  'pages.partners.startKyc': '开始 KYC 认证',

  // Reports
  'pages.reports.title': '报表中心',
  'pages.reports.selectAccount': '选择余额账户',
  'pages.reports.noAccount': '请先选择一个余额账户',
  'pages.reports.noBalanceAccounts': '暂无余额账户，请先创建余额账户。',

  // Disputes
  'pages.disputes.title': '争议处理',
  'pages.disputes.selectAccount': '选择余额账户',
  'pages.disputes.noAccount': '请先选择一个余额账户',
  'pages.disputes.noBalanceAccounts': '暂无余额账户，请先创建余额账户。',
  'pages.disputes.description':
    '查看和管理退款争议、欺诈警报，并提交抗辩材料。',

  // Stores
  'pages.stores.title': '门店',
  'pages.stores.id': '门店ID',
  'pages.stores.reference': '门店编号',
  'pages.stores.reference.placeholder': '请输入门店编号',
  'pages.stores.reference.required': '请输入门店编号',
  'pages.stores.reference.pattern': '只允许字母、数字、连字符和下划线',
  'pages.stores.reference.tooltip':
    '门店的唯一标识符（例如：merchant-123-store-A）',
  'pages.stores.description': '描述',
  'pages.stores.description.placeholder': '请输入门店描述（例如：悉尼旗舰店）',
  'pages.stores.description.required': '请输入门店描述',
  'pages.stores.shopperStatement': '消费者账单描述',
  'pages.stores.shopperStatement.placeholder': '请输入消费者账单描述',
  'pages.stores.shopperStatement.tooltip':
    '显示在客户银行账单上的文字（最多22个字符）',
  'pages.stores.status': '状态',
  'pages.stores.status.active': '活跃',
  'pages.stores.status.inactive': '未激活',
  'pages.stores.status.closed': '已关闭',
  'pages.stores.status.Active': '已激活',
  'pages.stores.status.Pending': '待审核',
  'pages.stores.status.Draft': '草稿',
  'pages.stores.status.Suspended': '已暂停',
  'pages.stores.status.Closed': '已关闭',
  'pages.stores.storeType': '店铺类型',
  'pages.stores.storeType.POS': 'POS',
  'pages.stores.storeType.ECommerce': '电子商务',
  'pages.stores.storeType.TapToPay': '碰一碰支付',
  'pages.stores.storeType.Others': '其他',
  'pages.stores.form.storeType': '店铺类型',
  'pages.stores.form.storeType.required': '请选择店铺类型',
  'pages.stores.form.storeType.placeholder': '选择店铺类型',
  'pages.stores.adyenStoreId': 'Adyen 门店 ID',
  'pages.stores.storeAddress': '门店地址',
  'pages.stores.splitConfigured': '分账配置',
  'pages.stores.splitConfigured.yes': '已配置',
  'pages.stores.splitConfigured.no': '未配置',
  'pages.stores.actions': '操作',
  'pages.stores.view': '查看',
  'pages.stores.edit': '编辑',
  'pages.stores.delete': '删除',
  'pages.stores.create': '创建门店',
  'pages.stores.createSuccess': '门店创建成功',
  'pages.stores.createError': '创建门店失败',
  'pages.stores.editTitle': '编辑门店',
  'pages.stores.editSuccess': '门店更新成功',
  'pages.stores.editError': '更新门店失败',
  'pages.store.businessLine': '业务线',
  'pages.stores.form.businessLine.required': '请选择业务线',
  'pages.stores.form.businessLine.noMatch':
    '所选店铺类型没有可用的业务线，请先创建业务线。',
  'pages.stores.deleteConfirm': '确定要删除此门店吗？',
  'pages.stores.deleteSuccess': '门店删除成功',
  'pages.stores.deleteError': '删除门店失败',
  'pages.stores.detailTitle': '门店详情',
  'pages.stores.noMerchantAccount': '未找到商户账户，请先完成入驻流程。',
  'pages.stores.noStores': '暂无门店。创建您的第一个门店以开始接收付款。',
  'pages.stores.tip.provideReference':
    '请将门店编号提供给您的 POS 服务商，以便其完成相关配置并将门店关联至其平台。',
  'pages.stores.createdAt': '创建时间',
  'pages.stores.merchantId': '商户ID',
  // Store Form
  'pages.stores.form.creationTitle': '创建门店',
  'pages.stores.form.creationDesc':
    '门店编号将由系统自动生成。支付分账将根据合作伙伴设置自动配置。',
  'pages.stores.form.storeName': '门店名称',
  'pages.stores.form.storeName.placeholder':
    '请输入门店名称（例如：悉尼旗舰店）',
  'pages.stores.form.storeName.required': '请输入门店名称',
  'pages.stores.form.storeName.maxLength': '最多 15 个字符',
  'pages.stores.form.description.optional': '描述（可选）',
  'pages.stores.form.description.optionalPlaceholder': '请输入门店描述（可选）',
  'pages.stores.form.phoneNumber': '电话号码',
  'pages.stores.form.phoneNumber.placeholder': '请输入电话号码',
  'pages.stores.form.phoneNumber.required': '电话号码为必填项',
  'pages.stores.form.phoneNumber.formatInvalid': '电话号码格式不正确',
  'pages.stores.form.country': '国家/地区',
  'pages.stores.form.country.placeholder': '请选择国家/地区',
  'pages.stores.form.country.required': '请选择国家/地区',
  'pages.stores.form.country.AU': '澳大利亚',
  'pages.stores.form.country.NZ': '新西兰',
  'pages.stores.form.line1': '地址第一行',
  'pages.stores.form.line1.placeholder': '请输入街道地址',
  'pages.stores.form.line1.required': '请输入地址第一行',
  'pages.stores.form.line2': '地址第二行',
  'pages.stores.form.line2.placeholder': '公寓、楼层等（可选）',
  'pages.stores.form.line3': '地址第三行',
  'pages.stores.form.line3.placeholder': '补充地址信息（可选）',
  'pages.stores.form.addressLine.invalidChars':
    '地址不能包含中文或全角字符（如 ，。），请使用英文半角字符',
  'pages.stores.form.city': '城市',
  'pages.stores.form.city.required': '请选择或输入城市',
  'pages.stores.form.city.select.placeholder': '请选择城市',
  'pages.stores.form.city.placeholder': '请输入城市',
  'pages.stores.form.postalCode': '邮政编码',
  'pages.stores.form.postalCode.placeholder': '请输入邮政编码',
  'pages.stores.form.postalCode.required': '请输入邮政编码',
  'pages.stores.form.stateOrProvince': '州/省',
  'pages.stores.form.stateOrProvince.placeholder': '请输入州或省',
  'pages.stores.form.stateOrProvince.autoFilled': '自动填充',
  'pages.stores.form.stateOrProvince.customHint':
    '请输入 ISO 代码（如 NSW、AUK）',
  'pages.stores.form.balanceAccount': '余额账户',
  'pages.stores.form.balanceAccount.required': '请选择余额账户',
  'pages.stores.form.status': '状态',

  // Register (Invitation)
  'pages.register.pageTitle': '注册',
  'pages.register.title': '完成注册',
  'pages.register.subtitle': '设置您的账户以开始使用',
  'pages.register.verifying': '正在验证您的邀请链接...',
  'pages.register.invalidLink': '邀请链接无效',
  'pages.register.invalidLinkDesc':
    '此邀请链接无效或已被使用，请联系管理员获取新的邀请。',
  'pages.register.expiredLink': '邀请已过期',
  'pages.register.expiredLinkDesc':
    '此邀请链接已过期，请联系管理员获取新的邀请。',
  'pages.register.usedLink': '邀请已使用',
  'pages.register.usedLinkDesc':
    '此邀请链接已被使用。如果您已注册，请直接登录。',
  'pages.register.success': '注册成功',
  'pages.register.successDesc':
    '您的账户已创建成功，现在可以使用邮箱和密码登录。',
  'pages.register.errorTitle': '注册失败',
  'pages.register.error': '注册失败，请重试。',
  'pages.register.role': '角色',
  'pages.register.organization': '组织',
  'pages.register.invitedBy': '邀请人',
  'pages.register.userName': '用户名',
  'pages.register.userNameRequired': '请输入用户名',
  'pages.register.userNameMinLength': '用户名至少3个字符',
  'pages.register.userNamePattern': '用户名只能包含字母、数字和下划线',
  'pages.register.displayName': '显示名称',
  'pages.register.displayNameRequired': '请输入显示名称',
  'pages.register.displayNameMinLength': '显示名称至少2个字符',
  'pages.register.phone': '手机号码',
  'pages.register.phoneRequired': '请输入手机号码',
  'pages.register.phonePattern': '请输入有效的手机号码',
  'pages.register.password': '密码',
  'pages.register.passwordRequired': '请输入密码',
  'pages.register.confirmPassword': '确认密码',
  'pages.register.confirmPasswordRequired': '请确认您的密码',
  'pages.register.passwordMismatch': '两次输入的密码不一致',
  'pages.register.passwordMinLength': '密码长度至少为8个字符',
  'pages.register.passwordComplexity': '密码必须包含大写字母、小写字母和数字',
  'pages.register.submit': '创建账户',
  'pages.register.hasAccount': '已有账户？',
  'pages.register.signIn': '登录',
  'pages.register.backToLogin': '返回登录',
  'pages.register.goToLogin': '前往登录',

  // Reset Password
  'pages.resetPassword.pageTitle': '重置密码',
  'pages.resetPassword.title': '重置您的密码',
  'pages.resetPassword.subtitle': '请在下方输入您的新密码',
  'pages.resetPassword.verifying': '正在验证重置链接...',
  'pages.resetPassword.invalidLink': '链接无效',
  'pages.resetPassword.invalidLinkDesc':
    '此密码重置链接无效或已被使用，请重新申请。',
  'pages.resetPassword.expiredLink': '链接已过期',
  'pages.resetPassword.expiredLinkDesc':
    '此密码重置链接已过期，请重新申请密码重置。',
  'pages.resetPassword.success': '密码重置成功',
  'pages.resetPassword.successDesc':
    '您的密码已成功重置，现在可以使用新密码登录。',
  'pages.resetPassword.errorTitle': '重置失败',
  'pages.resetPassword.error': '密码重置失败，请重试。',
  'pages.resetPassword.newPassword': '新密码',
  'pages.resetPassword.newPasswordRequired': '请输入新密码',
  'pages.resetPassword.confirmPassword': '确认新密码',
  'pages.resetPassword.confirmPasswordRequired': '请确认您的新密码',
  'pages.resetPassword.passwordMismatch': '两次输入的密码不一致',
  'pages.resetPassword.passwordMinLength': '密码长度至少为8个字符',
  'pages.resetPassword.passwordComplexity':
    '密码必须包含大写字母、小写字母和数字',
  'pages.resetPassword.submit': '重置密码',
  'pages.resetPassword.backToLogin': '返回登录',
  'pages.resetPassword.goToLogin': '前往登录',

  // Accept Invitation
  'pages.acceptInvitation.pageTitle': '接受邀请',
  'pages.acceptInvitation.title': '完成注册',
  'pages.acceptInvitation.subtitle':
    '您已被邀请加入 AimerPay，请设置您的账户信息。',
  'pages.acceptInvitation.verifying': '正在验证邀请链接...',
  'pages.acceptInvitation.invalidLink': '无效的邀请链接',
  'pages.acceptInvitation.invalidLinkDesc':
    '此邀请链接无效或已过期，请联系您的管理员。',
  'pages.acceptInvitation.expiredLink': '邀请已过期',
  'pages.acceptInvitation.expiredLinkDesc':
    '此邀请已过期，请联系管理员重新发送邀请。',
  'pages.acceptInvitation.usedLink': '邀请已使用',
  'pages.acceptInvitation.usedLinkDesc': '此邀请已被接受，请直接登录您的账户。',
  'pages.acceptInvitation.success': '注册完成！',
  'pages.acceptInvitation.successDesc': '您的账户已成功创建，正在为您跳转...',
  'pages.acceptInvitation.errorTitle': '注册失败',
  'pages.acceptInvitation.error': '注册失败，请重试。',
  'pages.acceptInvitation.field.email': '邮箱',
  'pages.acceptInvitation.field.role': '角色',
  'pages.acceptInvitation.field.userName': '用户名',
  'pages.acceptInvitation.field.userNameRequired': '请输入用户名',
  'pages.acceptInvitation.field.userNameMinLength': '用户名至少需要3个字符',
  'pages.acceptInvitation.field.displayName': '真实姓名',
  'pages.acceptInvitation.field.displayNameRequired': '请输入真实姓名',
  'pages.acceptInvitation.field.phone': '手机号码',
  'pages.acceptInvitation.field.phoneRequired': '请输入手机号码',
  'pages.acceptInvitation.field.password': '密码',
  'pages.acceptInvitation.field.passwordRequired': '请输入密码',
  'pages.acceptInvitation.field.passwordMinLength': '密码长度至少为8个字符',
  'pages.acceptInvitation.field.passwordComplexity':
    '密码必须包含大写字母、小写字母和数字',
  'pages.acceptInvitation.field.confirmPassword': '确认密码',
  'pages.acceptInvitation.field.confirmPasswordRequired': '请确认您的密码',
  'pages.acceptInvitation.field.passwordMismatch': '两次输入的密码不一致',
  'pages.acceptInvitation.submit': '完成注册',
  'pages.acceptInvitation.backToLogin': '已有账户？立即登录',
  'pages.acceptInvitation.goToLogin': '前往登录',
  'pages.acceptInvitation.goToDashboard': '前往控制台',

  // Personal Settings
  'pages.settings.title': '个人设置',
  'pages.settings.profile.title': '个人信息',
  'pages.settings.profile.name': '姓名',
  'pages.settings.profile.nameRequired': '请输入姓名',
  'pages.settings.profile.email': '邮箱',
  'pages.settings.profile.emailInvalid': '请输入有效的邮箱地址',
  'pages.settings.profile.phone': '电话',
  'pages.settings.profile.save': '保存更改',
  'pages.settings.profile.success': '个人信息更新成功',
  'pages.settings.profile.error': '更新个人信息失败',
  'pages.settings.avatar.change': '更换头像',
  'pages.settings.avatar.success': '头像更新成功',
  'pages.settings.security.title': '修改密码',
  'pages.settings.password.current': '当前密码',
  'pages.settings.password.currentRequired': '请输入当前密码',
  'pages.settings.password.currentPlaceholder': '请输入当前密码',
  'pages.settings.password.new': '新密码',
  'pages.settings.password.newRequired': '请输入新密码',
  'pages.settings.password.newPlaceholder': '请输入新密码',
  'pages.settings.password.confirm': '确认新密码',
  'pages.settings.password.confirmRequired': '请确认新密码',
  'pages.settings.password.confirmPlaceholder': '请再次输入新密码',
  'pages.settings.password.minLength': '密码长度至少为8个字符',
  'pages.settings.password.complexity': '密码必须包含大写字母、小写字母和数字',
  'pages.settings.password.mismatch': '两次输入的密码不一致',
  'pages.settings.password.submit': '修改密码',
  'pages.settings.password.success': '密码修改成功',
  'pages.settings.password.error': '密码修改失败',
  'pages.settings.password.wrongCurrent': '当前密码不正确',
  // Staff Invitation
  'pages.settings.invite.title': '邀请员工',
  'pages.settings.invite.description':
    '发送邀请邮件，添加新员工到您的商户账户。',
  'pages.settings.invite.email': '邮箱地址',
  'pages.settings.invite.emailPlaceholder': '输入员工邮箱地址',
  'pages.settings.invite.emailRequired': '请输入邮箱地址',
  'pages.settings.invite.emailInvalid': '请输入有效的邮箱地址',
  'pages.settings.invite.role': '角色',
  'pages.settings.invite.rolePlaceholder': '选择角色',
  'pages.settings.invite.roleRequired': '请选择角色',
  'pages.settings.invite.role.accountant': '会计',
  'pages.settings.invite.role.accountantDesc': '查看交易、报表和处理退款',
  'pages.settings.invite.role.viewer': '查看者',
  'pages.settings.invite.role.viewerDesc': '仅查看交易',
  'pages.settings.invite.submit': '发送邀请',
  'pages.settings.invite.success': '邀请已发送至 {email}',
  'pages.settings.invite.error': '发送邀请失败',

  // Staff Management
  'pages.staffManagement.title': '员工管理',
  'pages.staffManagement.noAccess': '您没有权限访问此页面。',
  'pages.staffManagement.invite.title': '邀请员工',
  'pages.staffManagement.invite.description':
    '发送邀请邮件，添加新员工到您的商户账户。',
  'pages.staffManagement.invite.email': '邮箱地址',
  'pages.staffManagement.invite.emailPlaceholder': '输入员工邮箱地址',
  'pages.staffManagement.invite.emailRequired': '请输入邮箱地址',
  'pages.staffManagement.invite.emailInvalid': '请输入有效的邮箱地址',
  'pages.staffManagement.invite.role': '角色',
  'pages.staffManagement.invite.rolePlaceholder': '选择角色',
  'pages.staffManagement.invite.roleRequired': '请选择角色',
  'pages.staffManagement.invite.role.accountant': '会计',
  'pages.staffManagement.invite.role.accountantDesc':
    '查看交易、报表和处理退款',
  'pages.staffManagement.invite.role.viewer': '查看者',
  'pages.staffManagement.invite.role.viewerDesc': '仅查看交易',
  'pages.staffManagement.invite.submit': '发送邀请',
  'pages.staffManagement.invite.success': '邀请已发送至 {email}',
  'pages.staffManagement.invite.error': '发送邀请失败',
  'pages.staffManagement.list.title': '员工列表',
  'pages.staffManagement.table.name': '姓名',
  'pages.staffManagement.table.username': '用户名',
  'pages.staffManagement.table.email': '邮箱',
  'pages.staffManagement.table.phone': '电话',
  'pages.staffManagement.table.role': '角色',
  'pages.staffManagement.table.status': '状态',
  'pages.staffManagement.table.invitedAt': '邀请时间',
  'pages.staffManagement.table.actions': '操作',
  'pages.staffManagement.role.accountant': '会计',
  'pages.staffManagement.role.viewer': '查看者',
  'pages.staffManagement.status.active': '已激活',
  'pages.staffManagement.status.inactive': '已停用',
  'pages.staffManagement.status.activated': '员工已激活',
  'pages.staffManagement.status.deactivated': '员工已停用',
  'pages.staffManagement.status.error': '更新员工状态失败',
  'pages.staffManagement.action.activate': '激活',
  'pages.staffManagement.action.deactivate': '停用',
  'pages.staffManagement.activate.confirm': '确定要激活此员工吗？',
  'pages.staffManagement.deactivate.confirm': '确定要停用此员工吗？',
  // Pending Invitations
  'pages.staffManagement.pending.title': '待处理邀请',
  'pages.staffManagement.pending.description':
    '已发送但尚未接受的邀请。已过期的邀请可以重新发送。',
  'pages.staffManagement.pending.email': '邮箱',
  'pages.staffManagement.pending.role': '角色',
  'pages.staffManagement.pending.sentAt': '发送时间',
  'pages.staffManagement.pending.expiresAt': '过期时间',
  'pages.staffManagement.pending.status': '状态',
  'pages.staffManagement.pending.actions': '操作',
  'pages.staffManagement.pending.expired': '已过期',
  'pages.staffManagement.pending.waiting': '等待中',
  'pages.staffManagement.pending.resend': '重新发送',
  'pages.staffManagement.pending.resendConfirm': '确定要重新发送此邀请吗？',
  'pages.staffManagement.pending.resendSuccess': '邀请已重新发送至 {email}',
  'pages.staffManagement.pending.resendError': '重新发送邀请失败',
  'pages.staffManagement.pending.resendNotExpired': '只能重新发送已过期的邀请',
  'pages.staffManagement.pending.resendDisabledTip': '只能重新发送已过期的邀请',

  // Partner Grants（跨 Owner 商家授权）
  'pages.partnerGrants.title': '商家授权',
  'pages.partnerGrants.noAccess': '您没有权限访问此页面。',
  'pages.partnerGrants.grant.title': '授权商家',
  'pages.partnerGrants.grant.description':
    '将您名下的部分商家授权给其他用户管理或查看。未注册的邮箱将收到邀请，接受后授权生效。',
  'pages.partnerGrants.grant.email': '邮箱地址',
  'pages.partnerGrants.grant.emailPlaceholder': '输入目标用户的邮箱地址',
  'pages.partnerGrants.grant.emailRequired': '请输入邮箱地址',
  'pages.partnerGrants.grant.emailInvalid': '请输入有效的邮箱地址',
  'pages.partnerGrants.grant.partners': '商家',
  'pages.partnerGrants.grant.partnersPlaceholder': '选择要授权的商家',
  'pages.partnerGrants.grant.partnersRequired': '请至少选择一个商家',
  'pages.partnerGrants.grant.role': '角色',
  'pages.partnerGrants.grant.rolePlaceholder': '选择角色',
  'pages.partnerGrants.grant.roleRequired': '请选择角色',
  'pages.partnerGrants.grant.role.owner': '受权管理者',
  'pages.partnerGrants.grant.role.ownerDesc':
    '完整管理权限，但不能邀请员工或再授权给他人',
  'pages.partnerGrants.grant.role.viewer': '受权查看者',
  'pages.partnerGrants.grant.role.viewerDesc': '只读权限（服务端强制）',
  'pages.partnerGrants.grant.submit': '授权',
  'pages.partnerGrants.grant.success': '已授权给 {email}',
  'pages.partnerGrants.grant.invited': '{email} 尚未注册，已发送邀请',
  'pages.partnerGrants.role.owner': '受权 · 管理',
  'pages.partnerGrants.role.viewer': '受权 · 只读',
  'pages.partnerGrants.list.title': '被授权用户',
  'pages.partnerGrants.table.name': '姓名',
  'pages.partnerGrants.table.email': '邮箱',
  'pages.partnerGrants.table.grants': '被授权商家',
  'pages.partnerGrants.table.actions': '操作',
  'pages.partnerGrants.expanded.partner': '商家',
  'pages.partnerGrants.expanded.role': '角色',
  'pages.partnerGrants.expanded.status': '状态',
  'pages.partnerGrants.expanded.grantedAt': '授权时间',
  'pages.partnerGrants.expanded.actions': '操作',
  'pages.partnerGrants.status.active': '生效中',
  'pages.partnerGrants.status.revoked': '已撤销',
  'pages.partnerGrants.action.revoke': '撤销',
  'pages.partnerGrants.action.revokeAll': '全部撤销',
  'pages.partnerGrants.revoke.confirm': '确定撤销该商家的授权吗？',
  'pages.partnerGrants.revokeAll.confirm': '确定撤销该用户的全部授权吗？',
  'pages.partnerGrants.revoke.success': '授权已撤销',
  'pages.partnerGrants.pending.title': '待接受的授权邀请',
  'pages.partnerGrants.pending.email': '邮箱',
  'pages.partnerGrants.pending.role': '角色',
  'pages.partnerGrants.pending.partners': '商家',
  'pages.partnerGrants.pending.sentAt': '发送时间',
  'pages.partnerGrants.pending.status': '状态',
  'pages.partnerGrants.pending.actions': '操作',
  'pages.partnerGrants.pending.expired': '已过期',
  'pages.partnerGrants.pending.waiting': '等待中',
  'pages.partnerGrants.action.cancelInvitation': '取消',
  'pages.partnerGrants.invitation.cancelConfirm': '确定取消此邀请吗？',
  'pages.partnerGrants.invitation.cancelled': '邀请已取消',
  'pages.merchantAccess.viewerRestricted':
    '您在当前商家仅有只读权限，无法访问此页面。',

  // Empty Merchants Component
  'components.emptyMerchants.title': '未选择商户',
  'components.emptyMerchants.description':
    '请从下拉菜单中选择商户，或创建新商户开始使用。',
  'components.emptyMerchants.description.noPermission':
    '请从下拉菜单中选择商户。商户由平台管理员创建，如需开通请联系平台管理员。',
  'components.emptyMerchants.createButton': '创建商户',

  // Common
  'pages.common.loading': '加载中...',
  'pages.common.error': '发生错误',
  'pages.common.retry': '重试',
  'pages.common.save': '保存',
  'pages.common.cancel': '取消',
  'pages.common.confirm': '确认',
  'pages.common.delete': '删除',
  'pages.common.search': '搜索',
  'pages.common.reset': '重置',
  'pages.common.export': '导出',
  'pages.common.import': '导入',
  'pages.common.refresh': '刷新',
  'pages.common.view': '查看',
  'pages.common.yes': '是',
  'pages.common.no': '否',
  'pages.common.done': '完成',

  // Status
  'pages.status.active': '已激活',
  'pages.status.inactive': '未激活',
  'pages.status.linked': '已关联',
  'pages.status.notCreated': '未创建',
  'pages.status.issues': '有问题',

  // Currency
  'pages.currency.aud': 'AUD - 澳元',
  'pages.currency.nzd': 'NZD - 新西兰元',
  'pages.currency.selectPlaceholder': '请选择币种',
  'pages.currency.selectRequired': '请选择币种',

  // Error States
  'pages.error.loadFailed': '加载客户失败',
  'pages.error.retryLater': '请稍后重试',
  'pages.error.notFound': '客户未找到',
  'pages.error.notFoundDesc': 'ID 为 {id} 的客户不存在或您没有访问权限。',
  'pages.error.noAccess': '您没有权限访问此页面。',
  'pages.error.noBalanceAccounts': '暂无余额账户，请先创建余额账户。',

  // Partner Detail
  'pages.partners.detail.legalName': '法定名称',
  'pages.partners.detail.address': '注册地址',
  'pages.partners.detail.firstName': '名',
  'pages.partners.detail.lastName': '姓',
  'pages.partners.detail.type': '类型',
  'pages.partners.detail.email': '邮箱',
  'pages.partners.detail.adyenAccountHolder': 'Adyen 账户持有人',
  'pages.partners.detail.balanceAccounts': '余额账户',
  'pages.partners.detail.adyenProfile': 'Adyen 方案',
  'pages.partners.detail.descriptionPlaceholder': '请输入描述（可选）',
  'pages.partners.detail.verificationAlert.title': '认证问题',
  'pages.partners.detail.verificationAlert.prompt':
    '请继续完成认证以解决以下问题：',
  'pages.partners.detail.verificationAlert.unknownError': '未知认证问题',
  'pages.partners.detail.setupAlert.title': '该商户尚未完成 Adyen 配置',
  'pages.partners.detail.setupAlert.prompt':
    '请点击右上角「设置 Adyen」继续完成配置，门店等后续操作需在配置完成后进行。',
  'pages.partners.detail.setupAlert.lastError': '上次失败原因：',
  'pages.partners.detail.continueVerification': '继续认证',

  // Business Lines
  'pages.businessLines.title': '业务线',
  'pages.businessLines.empty': '暂未配置业务线，请设置 Adyen 以创建。',
  'pages.businessLines.id': '业务线 ID',
  'pages.businessLines.service': '服务类型',
  'pages.businessLines.industryCode': '行业代码',
  'pages.businessLines.salesChannels': '销售渠道',
  'pages.businessLines.website': '网站',
  'pages.businessLines.create': '新增业务线',
  'pages.businessLines.createSuccess': '业务线创建成功',
  'pages.businessLines.createError': '创建业务线失败',
  'pages.businessLines.editTitle': '编辑业务线',
  'pages.businessLines.editSuccess': '业务线更新成功',
  'pages.businessLines.editError': '更新业务线失败',
  'pages.businessLines.deleteConfirm': '确定要删除此业务线吗？',
  'pages.businessLines.deleteSuccess': '业务线删除成功',
  'pages.businessLines.deleteError': '删除业务线失败',

  // Payment Methods
  'pages.paymentMethods.title': '支付方式',
  'pages.paymentMethods.empty': '暂未配置支付方式。',
  'pages.paymentMethods.add': '添加支付方式',
  'pages.paymentMethods.add.requiresStore': '请先创建门店',
  'pages.paymentMethods.createSuccess': '支付方式创建成功',
  'pages.paymentMethods.createError': '创建支付方式失败',
  'pages.paymentMethods.editTitle': '编辑支付方式',
  'pages.paymentMethods.editSuccess': '支付方式更新成功',
  'pages.paymentMethods.editError': '更新支付方式失败',
  'pages.paymentMethods.disable': '禁用',
  'pages.paymentMethods.disableConfirm': '确定要禁用此支付方式吗？',
  'pages.paymentMethods.disableSuccess': '支付方式已禁用',
  'pages.paymentMethods.disableError': '禁用支付方式失败',
  'pages.paymentMethods.type': '支付类型',
  'pages.paymentMethods.type.placeholder': '请选择支付类型',
  // Payment Type 下拉旁的 tooltip（Add Payment Method）。名称需与上方
  // pages.paymentMethods.type.* 的 label 保持一致。
  'pages.paymentMethods.type.tooltip':
    '为该门店开通哪种支付方式。括号内为 Adyen 类型代码。\n\n' +
    '卡类 —— Visa、万事达、美国运通、大来、银联 (CUP)：卡组织，线上线下渠道均可用。\n\n' +
    'Apple Pay：需注册网站域名（选中后在下方填写）。\n\n' +
    'Google Pay：需填写 Google Pay Merchant ID（选中后在下方填写）。\n\n' +
    '微信支付 Online（wechatpay）：线上微信支付的唯一开关。开通后默认覆盖所有线上变体 —— 包括桌面扫码 Desktop QR（wechatpayWeb，我们 kiosk 扫码收款使用的就是它）和 App 支付。这里没有单独的「WechatPay Desktop QR」选项，因为 Adyen 不提供这个门店级开关（分账规则里仍可单独选它 —— 规则匹配的是交易变体，不是开通开关）。开通需填写商户支持联系人（选中后在下方填写），且商户账号须已在 Adyen 签约微信支付。注意：桌面扫码开箱即用；手机浏览器 H5 场景需另行联系 Adyen Support 登记。\n\n' +
    '微信支付 POS（wechatpay_pos）：仅云终端微信收款。\n\n' +
    '支付宝（alipay）：一个类型、两个产品 —— eCommerce 渠道是支付宝（线上），pos 渠道是 Alipay+（线下）。选中后选择渠道。\n\n' +
    '支付宝 Wap（alipay_wap）：手机浏览器 H5 支付宝，仅线上。\n\n' +
    'EFTPOS 澳洲（eftpos_australia）：仅澳洲门店，固定以 AUD 结算。',
  'pages.paymentMethods.currencies': '支持币种',
  'pages.paymentMethods.currencies.placeholder': '请选择币种',
  'pages.paymentMethods.enabled': '启用状态',
  'pages.paymentMethods.shopperInteraction': '交互方式',
  'pages.paymentMethods.businessLine.placeholder': '请选择业务线',
  'pages.paymentMethods.stores': '门店',
  'pages.paymentMethods.stores.placeholder': '请选择门店',
  'pages.paymentMethods.applePay.domains.label': 'Apple Pay Web 域名',
  'pages.paymentMethods.applePay.domains.placeholder':
    '例如：shop.example.com（回车添加多个）',
  'pages.paymentMethods.applePay.domains.tooltip':
    '商户网站的域名列表（如 shop.example.com）。Apple Pay 按钮会出现在这些域名页面上。每个域名上必须托管 Adyen 提供的验证文件（路径 /.well-known/apple-developer-merchantid-domain-association），否则即便注册成功，实际支付时也无法激活。',
  'pages.paymentMethods.applePay.domains.extra':
    '不填或填错会导致 Adyen 返回 422 错误。POS 收银场景请勿启用 Apple Pay。',
  'pages.paymentMethods.applePay.domains.required':
    '请至少填写一个 Apple Pay 域名',
  'pages.paymentMethods.applePay.alert':
    'Apple Pay 注册前请确认：① 已在 Adyen Customer Area 获取域名验证文件；② 文件已托管在每个域名的 /.well-known/apple-developer-merchantid-domain-association 路径下可公网访问。否则即便接口返回成功，真实支付时也会失败。',
  'pages.paymentMethods.googlePay.merchantId.label': 'Google Pay Merchant ID',
  'pages.paymentMethods.googlePay.merchantId.placeholder':
    '例如：BCR2DN6TSXXXZ000',
  'pages.paymentMethods.googlePay.merchantId.tooltip':
    '商户在 Google Pay & Wallet Console (https://pay.google.com/business/console) 注册后，从控制台右上角获取的 ID。格式：16 位字母数字大写，或 20 位纯数字。⚠️ 这不是 Adyen 的 merchantAccount，也不是 Aimer 的店铺 ID。',
  'pages.paymentMethods.googlePay.merchantId.extra':
    '未注册的商户请先在 https://pay.google.com/business/console 完成注册并启用 Google Pay API。',
  'pages.paymentMethods.googlePay.merchantId.required':
    '请填写 Google Pay Merchant ID',
  'pages.paymentMethods.googlePay.merchantId.invalid':
    'Merchant ID 格式不正确：16 位字母数字大写，或 20 位纯数字',
  'pages.paymentMethods.googlePay.reuseMerchantId.label': '复用 Merchant ID',
  'pages.paymentMethods.googlePay.reuseMerchantId.tooltip':
    '如果同一个 Google Pay Merchant ID 已经被本平台的其他子商户用过，请打开此开关。多数情况保持关闭即可。',
  'pages.paymentMethods.googlePay.alert':
    'Google Pay 注册前请确认：① 已在 Google Pay & Wallet Console 完成商户注册；② 启用了 Google Pay API；③ 从右上角拿到了 Merchant ID。',
  'pages.paymentMethods.weChatPay.alert':
    '微信支付需要填写商户支持联系人姓名和邮箱。请确保你的商户账号已在 Adyen 开通微信支付。',
  'pages.paymentMethods.weChatPay.contactPersonName.label': '联系人姓名',
  'pages.paymentMethods.weChatPay.contactPersonName.required':
    '请填写联系人姓名',
  'pages.paymentMethods.weChatPay.contactPersonName.placeholder': '例如 张三',
  'pages.paymentMethods.weChatPay.email.label': '支持邮箱',
  'pages.paymentMethods.weChatPay.email.required': '请填写支持邮箱',
  'pages.paymentMethods.weChatPay.email.invalid': '请输入有效的邮箱地址',
  'pages.paymentMethods.weChatPay.email.placeholder':
    '例如 support@example.com',
  'pages.paymentMethods.prefillTip': '已按门店 / 商户资料预填，可修改。',
  // 支付宝 —— 线上线下共用同一个 type（alipay）：eCommerce 是支付宝，
  // pos 是 Alipay+。Adyen 要求必须显式指定渠道。
  'pages.paymentMethods.aliPay.alert':
    '支付宝的线上线下共用同一个支付方式类型：线上（eCommerce）是支付宝，线下（pos）是 Alipay+。该门店两个渠道都支持，请选择要开通的渠道。请确保你的商户账号已在 Adyen 开通支付宝。',
  'pages.paymentMethods.aliPay.autoPos':
    '该门店业务线仅支持线下（pos），将开通 Alipay+（线下）。',
  'pages.paymentMethods.aliPay.autoEcommerce':
    '该门店业务线仅支持线上（eCommerce），将开通支付宝（线上）。',
  'pages.paymentMethods.aliPay.wapAlert':
    '支付宝 Wap 仅支持线上，将固定开通到 eCommerce 渠道。',
  'pages.paymentMethods.aliPay.channel.label': '开通渠道',
  'pages.paymentMethods.aliPay.channel.required': '请选择开通渠道',
  'pages.paymentMethods.aliPay.channel.pos': 'Alipay+（线下 / pos）',
  'pages.paymentMethods.aliPay.channel.ecommerce': '支付宝（线上 / eCommerce）',
  // EFTPOS（澳洲）—— 仅澳洲门店可用，固定以 AUD 结算。Adyen 线上线下都支持，
  // 但线上 EFTPOS 需单独签约，所以渠道在此处选择。
  'pages.paymentMethods.eftpos.alert':
    'EFTPOS（澳洲）仅适用于澳洲门店，且固定以 AUD 结算（上方币种选择将被忽略）。线上 EFTPOS 需与 Adyen 单独签约——若只做线下收单，请保持默认。开通商户账号未签约的渠道会导致整个请求失败。',
  'pages.paymentMethods.eftpos.autoPos':
    '该门店业务线仅支持线下（pos），将开通线下 EFTPOS。固定以 AUD 结算（上方币种选择将被忽略）。',
  'pages.paymentMethods.eftpos.autoEcommerce':
    '该门店业务线仅支持线上（eCommerce），将开通线上 EFTPOS —— 该渠道需与 Adyen 单独签约。固定以 AUD 结算（上方币种选择将被忽略）。',
  'pages.paymentMethods.eftpos.channel.label': '开通渠道',
  'pages.paymentMethods.eftpos.channel.required': '请选择开通渠道',
  'pages.paymentMethods.eftpos.channel.pos': '线下 EFTPOS（pos）',
  'pages.paymentMethods.eftpos.channel.ecommerce':
    '线上 EFTPOS（eCommerce）—— 需单独签约',
  'pages.paymentMethods.eftpos.channel.both': '两个渠道都开',
  // 支付方式类型名称（列表列 + 类型下拉）
  'pages.paymentMethods.enabled.yes': '是',
  'pages.paymentMethods.enabled.no': '否',
  'pages.paymentMethods.type.visa': 'Visa',
  'pages.paymentMethods.type.mc': '万事达卡',
  'pages.paymentMethods.type.amex': '美国运通',
  'pages.paymentMethods.type.diners': '大来卡',
  'pages.paymentMethods.type.cup': '银联 (CUP)',
  'pages.paymentMethods.type.applepay': 'Apple Pay',
  'pages.paymentMethods.type.googlepay': 'Google Pay',
  'pages.paymentMethods.type.wechatpay': '微信支付 Online',
  'pages.paymentMethods.type.wechatpay_pos': '微信支付 POS',
  'pages.paymentMethods.type.alipay': '支付宝',
  'pages.paymentMethods.type.alipay_wap': '支付宝 Wap',
  'pages.paymentMethods.type.eftpos_australia': 'EFTPOS（澳洲）',
  'pages.paymentMethods.alreadyRequested':
    '该支付方式已存在（Adyen 限制同一 Store + BusinessLine + 类型只能存在一个）。如需更换参数，请先禁用现有配置，待 Adyen 90 天后自动清理，再创建新配置。',
  'pages.paymentMethods.applePay.editTip':
    'Apple Pay 域名可在下方"管理域名"区单独追加。⚠️ 追加后无法单独删除某个域名 — 如需删除，必须禁用此支付方式并重建。',
  'pages.paymentMethods.googlePay.editTip':
    'Google Pay 的 Merchant ID 创建后不可修改（Adyen 限制）。如需更换，请先禁用当前配置，Adyen 将在 90 天后自动清理，方可用相同 Store + BusinessLine 组合重新创建。',
  // Status column on PM list
  'pages.paymentMethods.status': '状态',
  'pages.paymentMethods.reviewStatus': '审核状态',
  'pages.paymentMethods.status.active': '已激活',
  'pages.paymentMethods.status.pending': '审核中',
  'pages.paymentMethods.status.inactive': '未启用',
  // Apple Pay domains management (post-creation)
  'pages.paymentMethods.applePay.domains.manage': '管理 Apple Pay 域名',
  'pages.paymentMethods.applePay.domains.current': '当前已注册的域名',
  'pages.paymentMethods.applePay.domains.add': '追加新域名',
  'pages.paymentMethods.applePay.domains.addPlaceholder':
    '输入域名后回车，可输入多个',
  'pages.paymentMethods.applePay.domains.addSuccess': '域名追加成功',
  'pages.paymentMethods.applePay.domains.addError': '域名追加失败',
  'pages.paymentMethods.applePay.domains.appendOnlyTip':
    '提示：此处仅支持追加。已注册的域名无法单独删除 — 如需删除，请禁用整个 Apple Pay 支付方式后重建。',
  'pages.paymentMethods.applePay.domains.empty': '尚未注册任何域名',
  'pages.paymentMethods.applePay.domains.loadError': '加载已注册域名失败',
  // shopperInteraction explicit selection (merchant-level)
  'pages.paymentMethods.shopperInteraction.placeholder': '请选择交互方式',
  'pages.paymentMethods.shopperInteraction.required': '请选择交互方式',
  'pages.paymentMethods.shopperInteraction.ecommerce': '在线支付 (eCommerce)',
  'pages.paymentMethods.shopperInteraction.pos': 'POS 收银 (pos)',
  'pages.paymentMethods.shopperInteraction.contAuth': '免接触授权 (contAuth)',
  'pages.paymentMethods.shopperInteraction.moto': '订单或电话 (moto)',

  // Terminals
  'pages.terminals.title': '终端设备',
  'pages.terminals.onboard': '添加终端',
  'pages.terminals.onboardTitle': '激活终端设备',
  'pages.terminals.onboardSuccess': '终端激活成功',
  'pages.terminals.onboardError': '终端激活失败',
  'pages.terminals.editTitle': '编辑终端',
  'pages.terminals.editSuccess': '终端更新成功',
  'pages.terminals.editError': '终端更新失败',
  'pages.terminals.reassignTitle': '重新分配终端',
  'pages.terminals.reassignSuccess': '终端重新分配成功',
  'pages.terminals.reassignError': '终端重新分配失败',
  'pages.terminals.deleteConfirm': '确定要删除此终端吗？',
  'pages.terminals.deleteSuccess': '终端删除成功',
  'pages.terminals.deleteError': '终端删除失败',
  'pages.terminals.syncSuccess': '终端同步成功',
  'pages.terminals.syncError': '终端同步失败',
  'pages.terminals.empty': '暂无终端设备，点击"添加终端"激活新设备',
  'pages.terminals.requiresActive': '商户必须处于激活状态才能添加终端',
  'pages.terminals.showOffline': '显示离线设备',
  'pages.terminals.offlineDisabled': '设备离线，无法操作',
  'pages.terminals.column.name': '终端名称',
  'pages.terminals.column.poiid': 'POIID',
  'pages.terminals.column.model': '型号',
  'pages.terminals.column.store': '所属门店',
  'pages.terminals.column.licenseKey': 'License Key',
  'pages.terminals.column.status': '状态',
  'pages.terminals.status.Boarded': '已激活',
  'pages.terminals.status.Offline': '离线',
  'pages.terminals.status.Unassigned': '未分配',
  'pages.terminals.status.Maintenance': '维护中',
  'pages.terminals.form.otp': 'OTP 验证码',
  'pages.terminals.form.otp.placeholder': '输入终端屏幕上显示的6位OTP',
  'pages.terminals.form.otp.required': '请输入OTP验证码',
  'pages.terminals.form.terminalName': '终端名称',
  'pages.terminals.form.terminalName.placeholder': '例如：收银台1',
  'pages.terminals.form.store': '分配到门店',
  'pages.terminals.form.store.placeholder': '选择门店（可选）',
  'pages.terminals.form.terminalType': '终端类型',
  'pages.terminals.form.licenseKey': 'License Key',
  'pages.terminals.form.licenseKey.placeholder':
    'Aimer POS License Key（可选）',
  'pages.terminals.form.ipAddress': 'IP 地址',
  'pages.terminals.form.ipAddress.placeholder': '例如：192.168.1.100（可选）',
  'pages.terminals.form.newStore': '新门店',
  'pages.terminals.form.newStore.placeholder': '选择新门店',
  'pages.terminals.form.newStore.required': '请选择门店',

  // ============ Surcharge ============
  'pages.surcharge.title.terminal': '附加费设置 — {name}',
  'pages.surcharge.title.store': '附加费设置（门店） — {name}',
  'pages.surcharge.title.default': '附加费设置',
  'pages.surcharge.usingInherited': '使用继承的公司默认配置',
  'pages.surcharge.storeLevelHint':
    '（门店级别 — 适用于此门店下所有 Tap to Pay 设备）',
  'pages.surcharge.noCustomConfig':
    '未找到自定义附加费配置（使用继承的默认值）',
  'pages.surcharge.saveSuccess': '附加费设置已保存',
  'pages.surcharge.saveError': '保存附加费设置失败',
  'pages.surcharge.resetConfirm': '确定恢复为继承的默认附加费配置？',
  'pages.surcharge.resetSuccess': '附加费已恢复为继承的默认配置',
  'pages.surcharge.resetError': '恢复附加费默认配置失败',
  'pages.surcharge.resetButton': '恢复默认',
  'pages.surcharge.askConfirmation': '询问消费者确认',
  'pages.surcharge.excludeGratuity': '小费不计入附加费',
  'pages.surcharge.rulesDivider': '按卡品牌设置附加费规则',
  'pages.surcharge.brand': '卡品牌',
  'pages.surcharge.brand.placeholder': '选择品牌',
  'pages.surcharge.brand.required': '必填',
  'pages.surcharge.source': '资金来源',
  'pages.surcharge.source.placeholder': '全部（默认）',
  'pages.surcharge.commercial': '仅商业卡',
  'pages.surcharge.currency': '币种',
  'pages.surcharge.percentage': '%（如 2.0）',
  'pages.surcharge.amount': '固定金额（分）',
  'pages.surcharge.maxAmount': '上限（分）',
  'pages.surcharge.addCurrency': '添加币种',
  'pages.surcharge.addRule': '添加卡品牌规则',

  // ============ Payments App Instances ============
  'pages.paymentsApps.title': '支付应用',
  'pages.paymentsApps.empty': '暂无已注册的支付应用实例。',
  'pages.paymentsApps.revokeConfirm':
    '确认吊销此支付应用实例？设备需要重新完成注册才能继续收款。',
  'pages.paymentsApps.revokeSuccess': '支付应用实例已吊销',
  'pages.paymentsApps.revokeError': '吊销支付应用实例失败',
  'pages.paymentsApps.alreadyRevoked': '已吊销',
  'pages.paymentsApps.column.installationId': 'Installation ID',
  'pages.paymentsApps.column.status': '状态',
  'pages.paymentsApps.column.merchantAccountCode': '商户账户',
  'pages.paymentsApps.column.merchantStoreCode': '门店代码',
  'pages.paymentsApps.status.ActiveForMaintenance': '活跃（维护）',
  'pages.paymentsApps.status.ActiveForPayment': '活跃（支付）',
  'pages.paymentsApps.status.PendingBoarding': '待注册',
  'pages.paymentsApps.status.Revoked': '已吊销',
  'pages.paymentsApps.status.BOARDED': '已注册',

  // ============ Transfer Instruments ============
  'pages.transferInstruments.title': '银行账户',
  'pages.transferInstruments.add': '添加银行账户',
  'pages.transferInstruments.accountNumber': '账户号码',
  'pages.transferInstruments.bankName': '银行名称',
  'pages.transferInstruments.bankNamePlaceholder': '如：ANZ、ASB、Westpac',
  'pages.transferInstruments.bsbCode': 'BSB 代码',
  'pages.transferInstruments.onboardInfo':
    '您可以通过 Adyen 入驻页面添加银行账户。请点击上方的"入驻"按钮进行操作。',
  'pages.transferInstruments.currency': '币种',
  'pages.transferInstruments.country': '国家',
  'pages.transferInstruments.createSuccess': '银行账户添加成功',
  'pages.transferInstruments.createError': '银行账户添加失败',
  'pages.transferInstruments.deleteSuccess': '银行账户已删除',
  'pages.transferInstruments.deleteError': '银行账户删除失败',
  'pages.transferInstruments.deleteConfirm': '确定要删除此银行账户吗？',
  'pages.transferInstruments.empty': '暂无银行账户',
  'pages.transferInstruments.detailTitle': '银行账户详情',
  'pages.transferInstruments.type': '类型',
  'pages.transferInstruments.trustedSource': '可信来源',
  'pages.transferInstruments.yes': '是',
  'pages.transferInstruments.no': '否',
  'pages.transferInstruments.capabilities': '功能权限',
  'pages.transferInstruments.allowed': '已允许',
  'pages.transferInstruments.notAllowed': '未允许',

  // ============ Sweeps ============
  'pages.sweeps.title': '自动提现',
  'pages.sweeps.create': '创建提现规则',
  'pages.sweeps.edit': '编辑提现规则',
  'pages.sweeps.bankAccount': '银行账户',
  'pages.sweeps.transferTo': '转账至',
  'pages.sweeps.schedule': '频率',
  'pages.sweeps.scheduleDescription':
    '每天早上 7:00 自动提现，采用余额账户设置的时区',
  'pages.sweeps.schedule.daily9am': '每天 7:00 AM',
  'pages.sweeps.triggerAmount': '触发金额',
  'pages.sweeps.triggerAmountTip': '余额超过此金额时触发提现',
  'pages.sweeps.targetAmount': '保留金额',
  'pages.sweeps.targetAmountTip': '提现后账户中保留的金额',
  'pages.sweeps.status': '状态',
  'pages.sweeps.status.active': '启用',
  'pages.sweeps.status.inactive': '停用',
  'pages.sweeps.createSuccess': '提现规则创建成功',
  'pages.sweeps.createError': '提现规则创建失败',
  'pages.sweeps.updateSuccess': '提现规则更新成功',
  'pages.sweeps.updateError': '提现规则更新失败',
  'pages.sweeps.deleteSuccess': '提现规则已删除',
  'pages.sweeps.deleteError': '提现规则删除失败',
  'pages.sweeps.deleteConfirm': '确定要删除此提现规则吗？',
  'pages.sweeps.statusUpdated': '提现规则状态已更新',
  'pages.sweeps.noBankAccount': '请先在商家详情页添加银行账户',
  'pages.sweeps.cronPreset': '频率预设',
  'pages.sweeps.cronExpression': 'Cron 表达式',
  'pages.sweeps.cronExpression.tooltip':
    'Cron 表达式格式：分 时 日 月 周（例如：0 7 * * * 表示每天上午 7 点）',
  'pages.sweeps.cronExpression.invalid': '请输入有效的 Cron 表达式',

  // Admin - Merchant Access Requests (SuperAdmin approval queue)
  'pages.admin.accessRequests.title': '商户访问审批',
  'pages.admin.accessRequests.requester': '申请人',
  'pages.admin.accessRequests.owner': '商户所有者',
  'pages.admin.accessRequests.requestedAt': '申请时间',
  'pages.admin.accessRequests.actions': '操作',
  'pages.admin.accessRequests.approve': '批准',
  'pages.admin.accessRequests.reject': '拒绝',
  'pages.admin.accessRequests.approveTitle': '批准访问申请',
  'pages.admin.accessRequests.rejectTitle': '拒绝访问申请',
  'pages.admin.accessRequests.durationLabel': '授权时长',
  'pages.admin.accessRequests.duration.1h': '1 小时',
  'pages.admin.accessRequests.duration.4h': '4 小时',
  'pages.admin.accessRequests.duration.8h': '8 小时',
  'pages.admin.accessRequests.duration.1d': '1 天',
  'pages.admin.accessRequests.duration.3d': '3 天',
  'pages.admin.accessRequests.rejectReasonPlaceholder': '拒绝原因（可选）',
  'pages.admin.accessRequests.approveSuccess': '申请已批准',
  'pages.admin.accessRequests.rejectSuccess': '申请已拒绝',
  'pages.admin.accessRequests.empty': '暂无待审批申请',

  // Admin - Split Configuration
  'pages.admin.splitConfig.title': '分账配置管理',
  'pages.admin.splitConfig.tab.configs': '分账配置列表',
  'pages.admin.splitConfig.tab.storeAssignment': '店铺分配',
  'pages.admin.splitConfig.column.description': '描述',
  'pages.admin.splitConfig.column.commissionRate': '佣金比例',
  'pages.admin.splitConfig.column.fixedFee': '固定费用',
  'pages.admin.splitConfig.column.configId': '配置 ID',
  'pages.admin.splitConfig.column.currentConfig': '当前配置',
  'pages.admin.splitConfig.globalDefault': '全局默认',
  'pages.admin.splitConfig.create': '创建配置',
  'pages.admin.splitConfig.create.success': '分账配置创建成功',
  'pages.admin.splitConfig.create.error': '分账配置创建失败',
  'pages.admin.splitConfig.createModal.title': '创建分账配置',
  'pages.admin.splitConfig.action.rename': '重命名',
  'pages.admin.splitConfig.editDescriptionModal.title': '编辑描述',
  'pages.admin.splitConfig.editDescription': '更新描述',
  'pages.admin.splitConfig.editDescription.success': '描述更新成功',
  'pages.admin.splitConfig.editDescription.error': '描述更新失败',
  'pages.admin.splitConfig.form.descriptionMaxLength':
    '描述不能超过 300 个字符',
  'pages.admin.splitConfig.assign': '分配',
  'pages.admin.splitConfig.assign.success': '分账配置分配成功',
  'pages.admin.splitConfig.assign.modalTitle': '为 {store} 分配分账配置',
  'pages.admin.splitConfig.clear': '清除',
  'pages.admin.splitConfig.clear.confirm': '清除分账配置',
  'pages.admin.splitConfig.clear.confirmContent':
    '这将使店铺 "{name}" 恢复使用全局默认配置，确认继续？',
  'pages.admin.splitConfig.clear.success':
    '分账配置已清除，店铺将使用全局默认配置。',
  'pages.admin.splitConfig.form.description': '描述',
  'pages.admin.splitConfig.form.commissionRate': '佣金比例 (%)',
  'pages.admin.splitConfig.form.fixedFee': '固定费用 ({currency})',
  'pages.admin.splitConfig.form.selectConfig': '分账配置',
  'pages.admin.splitConfig.form.balanceAccountId': 'Adyen 余额账户 ID',
  'pages.admin.splitConfig.partners': '商户列表',
  'pages.admin.splitConfig.stores': '店铺列表',
  'pages.admin.splitConfig.selectPartner': '请选择商户以查看店铺',
  'pages.admin.splitConfig.noPartners': '暂无商户',
  'pages.admin.splitConfig.noStores': '该商户暂无店铺',
  'pages.admin.splitConfig.profile.label': 'Adyen 账号方案',
  'pages.admin.splitConfig.profile.switchHint':
    '切换 profile 将重新加载该商户账户下的配置。',
  'pages.admin.splitConfig.delete.disabledHint':
    '这是该 profile 的默认 split configuration，无法删除。请先指定其他配置为默认。',
  'pages.admin.splitConfig.tab.byConfig': '按配置分配',
  'pages.admin.splitConfig.column.partner': '客户',
  'pages.admin.splitConfig.column.store': '店铺',
  'pages.admin.splitConfig.column.status': '状态',
  'pages.admin.splitConfig.unassign': '取消分配',
  'pages.admin.splitConfig.unknownConfig': '未知配置',
  'pages.admin.splitConfig.staleLabel': '未知配置（已失效）',
  'pages.admin.splitConfig.explicitDefaultTooltip':
    '已显式设为该商户账户的默认配置',
  'pages.admin.splitConfig.searchStoresPlaceholder': '按店铺名、标签或客户搜索',

  // Admin - Invitations
  'pages.admin.invitations.title': '平台用户邀请',
  'pages.admin.invitations.inviteTitle': '邀请平台用户',
  'pages.admin.invitations.inviteDesc':
    '发送邀请以添加平台用户（超级管理员或平台管理员）。被邀请人将收到一封包含账户设置链接的邮件。',
  'pages.admin.invitations.emailPlaceholder': '请输入邮箱地址',
  'pages.admin.invitations.pendingTitle': '待处理邀请',
  'pages.admin.invitations.noInvitations': '暂无待处理邀请',
  'pages.admin.invitations.pendingRole': '角色',
  'pages.admin.invitations.success': '邀请发送成功',
  'pages.admin.invitations.error': '邀请发送失败',
  'pages.admin.invitations.role.label': '角色',
  'pages.admin.invitations.role.placeholder': '请选择要邀请的角色',
  'pages.admin.invitations.role.required': '请选择角色',
  'pages.admin.invitations.role.superAdmin': '超级管理员 / SuperAdmin',
  'pages.admin.invitations.role.admin': '平台管理员 / Admin',

  // Merchant Owners page (SuperAdmin)
  'pages.merchantOwners.title': '商户所有者管理',
  'pages.merchantOwners.name': '商户所有者',
  'pages.merchantOwners.username': '用户名',
  'pages.merchantOwners.partnerCount': '商户数量',
  'pages.merchantOwners.partners': '关联商户',
  'pages.merchantOwners.enter': '进入',
  'pages.merchantOwners.searchPlaceholder':
    '名称 / 邮箱 / 商户 / 店铺 / 店铺ID / 标签',

  // Common table
  'pages.table.titleOption': '操作',

  // Split config form
  'pages.admin.splitConfig.form.balanceAccountEmpty': '该商户暂无余额账户',

  // Split config form - Rule Conditions
  'pages.admin.splitConfig.form.ruleConditions': '规则条件',
  'pages.admin.splitConfig.form.currency': '币种',
  'pages.admin.splitConfig.form.currency.tooltip':
    '决定此规则适用于哪些币种的交易。ANY = 所有币种。',
  'pages.admin.splitConfig.form.paymentMethod': '支付方式',
  'pages.admin.splitConfig.form.paymentMethod.tooltip':
    '决定此规则适用于哪些支付方式。ANY = 所有支付方式。\n\n' +
    '卡类（Visa / MC / Amex / Diners / UnionPay / EFTPOS）：匹配所有刷卡渠道 — 在线结账、云终端、Tap to Pay、POS Mobile SDK、终端直付。\n\n' +
    'Alipay / Alipay+（alipay）：同时覆盖两个渠道 — 线上 kiosk 扫码（Alipay）与云终端（Alipay+）。要按渠道差异化定价，需配合渠道（Shopper Interaction）条件（Ecommerce / POS）。\n\n' +
    'Alipay Wap（alipay_wap）：手机浏览器 H5 支付宝。\n\n' +
    'WechatPay Online（wechatpay）：线上微信支付基础变体。\n\n' +
    'WechatPay Desktop QR（wechatpayWeb）：在桌面/kiosk 屏幕上展示二维码，顾客用微信 App 扫码支付。\n\n' +
    'WechatPay POS（wechatpay_pos）：仅云终端微信收款。',
  'pages.admin.splitConfig.form.cardRegion': '卡地区',
  'pages.admin.splitConfig.form.cardRegion.tooltip':
    '根据发卡行与商户所在地关系匹配。Domestic = 同一国家；International = 不同国家/地区。Pilot 功能 — 需联系 Adyen 启用，否则创建会失败。',
  'pages.admin.splitConfig.column.conditions': '规则条件',
  'pages.admin.splitConfig.column.conditions.catchAll': '全部（默认规则）',
  'pages.admin.splitConfig.form.fundingSource': '资金来源',
  'pages.admin.splitConfig.form.fundingSource.tooltip':
    '决定此规则适用于哪种卡类型。ANY = 所有卡类型。可用于区分信用卡和借记卡定价。',
  'pages.admin.splitConfig.form.shopperInteraction': '销售渠道',
  'pages.admin.splitConfig.form.shopperInteraction.tooltip':
    '决定此规则适用于哪个销售渠道。Ecommerce = 线上；POS = 线下终端；ContAuth = 订阅/存档卡。',

  // Split config form - Advanced Split Logic
  'pages.admin.splitConfig.form.advancedSettings': '高级分账逻辑设置',
  'pages.admin.splitConfig.form.paymentFee': '交易手续费',
  'pages.admin.splitConfig.form.paymentFee.tooltip':
    '交易手续费由谁承担。平台承担 = 从平台 liable 账户扣除；商户承担 = 从商户 balance account 扣除。',
  'pages.admin.splitConfig.form.refund': '退款处理',
  'pages.admin.splitConfig.form.refund.tooltip':
    '退款时资金从哪里扣回。按比例退回 = 按原分账比例从各方扣回（推荐）。平台/商户 = 从单一账户扣回。',
  'pages.admin.splitConfig.form.chargeback': '拒付处理',
  'pages.admin.splitConfig.form.chargeback.tooltip':
    '拒付（chargeback）时资金从哪里扣回。平台承担 = 平台承担拒付风险（默认）。按比例 = 按分账比例扣回。',

  // Rule-level CRUD & shared actions
  'pages.admin.splitConfig.confirm': '是',
  'pages.admin.splitConfig.cancel': '否',
  'pages.admin.splitConfig.column.actions': '操作',
  'pages.admin.splitConfig.column.rules': '条规则',
  'pages.admin.splitConfig.delete': '删除配置',
  'pages.admin.splitConfig.delete.confirm': '确定删除整个分账配置？',
  'pages.admin.splitConfig.delete.description':
    '此操作将删除该配置及其所有规则。使用该配置的门店将回退到全局默认配置。',
  'pages.admin.splitConfig.delete.success': '分账配置删除成功',
  'pages.admin.splitConfig.delete.error': '删除分账配置失败',
  'pages.admin.splitConfig.rule.add': '添加规则',
  'pages.admin.splitConfig.rule.addModal.title': '添加规则',
  'pages.admin.splitConfig.rule.add.success': '规则添加成功',
  'pages.admin.splitConfig.rule.add.error': '添加规则失败',
  'pages.admin.splitConfig.rule.editConditions': '编辑条件',
  'pages.admin.splitConfig.rule.conditionsModal.title': '编辑规则条件',
  'pages.admin.splitConfig.rule.conditions.success': '规则条件更新成功',
  'pages.admin.splitConfig.rule.conditions.error': '更新规则条件失败',
  'pages.admin.splitConfig.rule.editFee': '编辑费率',
  'pages.admin.splitConfig.rule.feeModal.title': '编辑规则费率',
  'pages.admin.splitConfig.rule.fee.success': '规则费率更新成功',
  'pages.admin.splitConfig.rule.fee.error': '更新规则费率失败',
  'pages.admin.splitConfig.rule.delete': '删除规则',
  'pages.admin.splitConfig.rule.delete.confirm': '确定删除此规则？',
  'pages.admin.splitConfig.rule.delete.success': '规则删除成功',
  'pages.admin.splitConfig.rule.delete.error': '删除规则失败',
  'pages.admin.splitConfig.form.refundCostAllocation': '退款成本归属',
  'pages.admin.splitConfig.form.chargebackCostAllocation': '拒付成本归属',
  'pages.admin.splitConfig.form.remainder': '汇兑余额归属',
  'pages.admin.splitConfig.form.balanceAccountPlaceholder': '请选择余额账户',
  'pages.admin.splitConfig.form.balanceAccountRequired': '请选择余额账户',
  'pages.admin.splitConfig.noStores.tag': '没有匹配该标签的门店',
  'pages.admin.splitConfig.stores.tagResults': '标签 "{query}" 的搜索结果',
  'pages.admin.splitConfig.stores.tagSearchPlaceholder':
    '按标签搜索门店（如 newbyRoad）',

  // Live split-configuration binding viewer (per-store modal)
  'pages.admin.splitConfig.viewSplitConfig.action': '查看实际绑定',
  'pages.admin.splitConfig.viewSplitConfig.modalTitle': '分账配置 — {store}',
  'pages.admin.splitConfig.viewSplitConfig.loadFailed':
    '从 Adyen 加载实际绑定失败，请重试。',
  'pages.admin.splitConfig.viewSplitConfig.notBound': 'Adyen 侧未绑定',
  'pages.admin.splitConfig.viewSplitConfig.notBoundDetail':
    '该门店在 Adyen 没有绑定任何分账配置，因此交易不会分账 — 资金不会进入商家余额账户。可通过「分配」指定一个，或「清除」重新绑定 profile 默认配置。',
  'pages.admin.splitConfig.viewSplitConfig.usingDefault':
    '已绑定 profile 默认配置',
  'pages.admin.splitConfig.viewSplitConfig.usingOverride': '已绑定指定配置',
  'pages.admin.splitConfig.viewSplitConfig.localDrift':
    '本地记录与 Adyen 不一致',
  'pages.admin.splitConfig.viewSplitConfig.localDriftDetail':
    '可先同步门店以刷新本地记录（仅供参考 — 一切以 Adyen 为准）。',
  'pages.admin.splitConfig.viewSplitConfig.adyenBinding': 'Adyen 绑定（实时）',
  'pages.admin.splitConfig.viewSplitConfig.adyenBa': 'Adyen 余额账户（实时）',
  'pages.admin.splitConfig.viewSplitConfig.profileDefault': 'Profile 默认配置',
  'pages.admin.splitConfig.viewSplitConfig.localRecord': '本地记录',

  // Advanced split-logic labels & tooltips
  'pages.admin.splitConfig.form.surcharge': '附加费归属',
  'pages.admin.splitConfig.form.surcharge.tooltip':
    '向持卡人收取的附加费（surcharge）记入哪个账户。',
  'pages.admin.splitConfig.form.tip': '小费归属',
  'pages.admin.splitConfig.form.tip.tooltip': '小费（gratuity）记入哪个账户。',
  'pages.admin.splitConfig.form.refundCostAllocation.tooltip':
    '退款处理成本由谁承担。',
  'pages.admin.splitConfig.form.chargebackCostAllocation.tooltip':
    '拒付处理成本由谁承担。',
  'pages.admin.splitConfig.form.remainder.tooltip':
    '汇率转换后的余额记入哪个账户。',
  'pages.admin.splitConfig.form.notSet': '未设置',
  'pages.admin.splitConfig.form.descriptionPlaceholder':
    '例如：平台佣金 5% + $0.30',
  'pages.admin.splitConfig.form.selectConfigPlaceholder': '请选择分账配置',

  // Nested rule table headers & shared actions
  'pages.admin.splitConfig.column.ruleId': '规则 ID',
  'pages.admin.splitConfig.column.pm': '支付方式 (PM)',
  'pages.admin.splitConfig.column.channel': '购物者交互',
  'pages.admin.splitConfig.column.currency': '币种',
  'pages.admin.splitConfig.column.funding': '资金来源',
  'pages.admin.splitConfig.column.region': '卡地区',
  'pages.admin.splitConfig.action.cancel': '取消',
  'pages.admin.splitConfig.action.copied': '已复制！',
  'pages.admin.splitConfig.action.copyId': '复制 ID',

  // Multi-rule create
  'pages.admin.splitConfig.create.ruleLabel': '规则 {index}',
  'pages.admin.splitConfig.create.addRule': '添加规则',
  'pages.admin.splitConfig.create.removeRule': '移除',
};
